<form
  class="popover__content"
  #myForm="ngForm"
  (click)="$event.stopPropagation()"
  [formGroup]="dynamicForm">
  <!-- <form class="popover__content"  id="myForm"  #filterForm="ngForm" (ngSubmit)="registerUser(filterForm)"> -->
  <div class="filter-container">
    <table>
      <ng-container *ngFor="let filter of _filters; let i = index">
        <tr class="filter-container-row">
          <td formArrayName="formCheckBoxes">
            <mat-checkbox
              #fil
              (change)="disableEnableInput(i, fil.checked)"
              [formControlName]="i"></mat-checkbox>
            <!-- <input type="checkbox" id="{{filter.name}}_checkbox" #fil (change)="disableEnableInput(i, fil.checked)" [value]="i" formControlName="name" /> -->
          </td>
          <ng-container formArrayName="formFilters">
            <ng-container [formGroupName]="i">
              <td>
                <p>{{ filter.name }}</p>
              </td>
              <td>
                <mat-select
                  [disabled]="!fil.checked"
                  formControlName="condition"
                  placeholder="Select"
                  style="width: 100px">
                  <mat-option
                    *ngFor="let condition of FilterCondition[filter.type]"
                    value="{{ condition }}">
                    {{ condition }}
                  </mat-option>
                </mat-select>
              </td>
              <td>
                <mat-form-field>
                  <!-- <mat-label>Enter {{filter.name}}</mat-label> -->
                  <input
                    [disabled]="!fil.checked"
                    formControlName="value"
                    *ngIf="filter.type == 'string' || filter.type == 'number'"
                    matInput
                    type="{{ filter.type }}"
                    placeholder="Enter {{ filter.name }}" />
                  <mat-select
                    [disabled]="!fil.checked"
                    formControlName="value"
                    *ngIf="filter.type == 'array' || filter.type == 'boolean'"
                    placeholder="Select {{ filter.name }}">
                    <mat-option
                      *ngFor="let value of filter.values"
                      [value]="value"
                      >{{ value }}</mat-option
                    >
                  </mat-select>
                  <mat-select
                    [disabled]="!fil.checked"
                    *ngIf="filter.type == 'multiselect'"
                    placeholder="Select {{ filter.name }}"
                    formArrayName="value"
                    multiple
                    [value]="getValueOfFormControl(i)">
                    <mat-option
                      *ngFor="let value of filter.values"
                      (click)="addRemoveValueToControl(value, i)"
                      [value]="value">
                      {{ value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>
          </ng-container>
        </tr>
      </ng-container>
    </table>
  </div>
  <div style="display: flex; justify-content: space-around">
    <button mat-raised-button (click)="onSubmitFilterForm()">Apply</button>
    <button mat-raised-button (click)="onClearFilterForm()">Reset</button>
  </div>
</form>
<!-- 
{{this.dynamicForm.value | json}} -->
